import ReactiveComponent, { watch } from '../../utils/reactive-component';
import template from './templates';

const DEFAULT_OPTIONS = {
    aria: true,
    ariaLive: 'polite',
    className: '',
    customIcon: null,
    light: false,
    replaceOriginEl: true,
    size: '',
    srText: 'Loading...',
    visible: false
};

export default class AjaxLoader extends ReactiveComponent {
    constructor($originEl, options) {
        super();

        options = {
            ...DEFAULT_OPTIONS,
            ...options
        };

        const parsedTemplate = $.parseHTML(template(options));

        this.$el = $(parsedTemplate);
        this.$originEl = $originEl;
        this.$loader = this.$el.find('[data-region="loader"]');

        this.replaceOriginEl = options.replaceOriginEl;

        this.reactive({
            active: options.visible
        });

        this.init();

        if(options.visible) {
            this.render();
        }
    }

    [watch]() {
        return { active: this.updateState };
    }

    init() {
        this.updateState();
    }

    updateState() {
        if(this.active) {
            this.$loader.addClass('-active');
        } else {
            this.$loader.removeClass('-active');
        }
    }

    render() {
        if(this.$originEl) {
            if(this.replaceOriginEl) {
                this.$originEl.replaceWith(this.$el);
            } else {
                this.$originEl.html(this.$el);
            }
        }

        return this.$el;
    }
}

$(() => {
    $('.js-ajax-loader').each(function() {
        const $el = $(this);
        const options = {
            aria: $el.data('aria') ?? DEFAULT_OPTIONS.aria,
            ariaLive: $el.data('aria-live') || DEFAULT_OPTIONS.ariaLive,
            className: $el.data('class-name') || DEFAULT_OPTIONS.className,
            customIcon: $el.data('custom-icon') || DEFAULT_OPTIONS.customIcon,
            light: $el.data('light') || DEFAULT_OPTIONS.light,
            replaceOriginEl: DEFAULT_OPTIONS.replaceOriginEl,
            size: $el.data('size') || DEFAULT_OPTIONS.size,
            srText: $el.data('sr-text') || DEFAULT_OPTIONS.srText,
            visible: true
        };
    
        new AjaxLoader($el, options);
    });
});
